/** @format */
import { _$, Tooltip } from '@king-design/react'
import React, { FC, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/store'
import { getUsers } from 'src/store/userSlice'
const UserInfo: FC<{ name: string }> = ({ name }) => {
  const dispatch = useDispatch()
  const users = useSelector((state: RootState) => state.users)

  useEffect(() => {
    dispatch(getUsers())
  }, [dispatch])

  const findUser = useMemo(() => {
    return users?.find(user => user.name?.toLowerCase() === name?.toLowerCase())
  }, [users, name])

  return findUser ? (
    <Tooltip
      slotContent={
        <>
          <p style={{ margin: '4px 0' }}>
            {_$('姓名')}：{`${findUser?.cname}（${name}）`}
          </p>
          <p style={{ margin: '4px 0' }}>
            {_$('工号')}：{findUser?.code}
          </p>
          <p style={{ margin: '4px 0' }}>
            {_$('电话')}：{findUser?.phone}
          </p>
        </>
      }
    >
      {findUser?.cname}
    </Tooltip>
  ) : (
    <span>{name}</span>
  )
}
export default UserInfo
